module.exports = __webpack_public_path__ + "img/superiority.97ee79d1.png";